/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DateTimeRestrictionValidationData,
    DateTimeRestrictionValidationDataFromJSON,
    DateTimeRestrictionValidationDataFromJSONTyped,
    DateTimeRestrictionValidationDataToJSON,
    ListItemValidationMessage,
    ListItemValidationMessageFromJSON,
    ListItemValidationMessageFromJSONTyped,
    ListItemValidationMessageToJSON,
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface OsisRuleValidationData
 */
export interface OsisRuleValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof OsisRuleValidationData
     */
    description?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof OsisRuleValidationData
     */
    marketingCarriers?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof OsisRuleValidationData
     */
    dateTimeRestrictionsTimeZone?: ValidationMessage;
    /**
     * 
     * @type {Array<DateTimeRestrictionValidationData>}
     * @memberof OsisRuleValidationData
     */
    dateTimeRestrictions?: Array<DateTimeRestrictionValidationData> | null;
    /**
     * 
     * @type {Array<ListItemValidationMessage>}
     * @memberof OsisRuleValidationData
     */
    fareBasisCodes?: Array<ListItemValidationMessage> | null;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof OsisRuleValidationData
     */
    brandAndMarket?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof OsisRuleValidationData
     */
    osIs?: ValidationMessage;
}

export function OsisRuleValidationDataFromJSON(json: any): OsisRuleValidationData {
    return OsisRuleValidationDataFromJSONTyped(json, false);
}

export function OsisRuleValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): OsisRuleValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : ValidationMessageFromJSON(json['description']),
        'marketingCarriers': !exists(json, 'marketingCarriers') ? undefined : ValidationMessageFromJSON(json['marketingCarriers']),
        'dateTimeRestrictionsTimeZone': !exists(json, 'dateTimeRestrictionsTimeZone') ? undefined : ValidationMessageFromJSON(json['dateTimeRestrictionsTimeZone']),
        'dateTimeRestrictions': !exists(json, 'dateTimeRestrictions') ? undefined : (json['dateTimeRestrictions'] === null ? null : (json['dateTimeRestrictions'] as Array<any>).map(DateTimeRestrictionValidationDataFromJSON)),
        'fareBasisCodes': !exists(json, 'fareBasisCodes') ? undefined : (json['fareBasisCodes'] === null ? null : (json['fareBasisCodes'] as Array<any>).map(ListItemValidationMessageFromJSON)),
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : ValidationMessageFromJSON(json['brandAndMarket']),
        'osIs': !exists(json, 'osIs') ? undefined : ValidationMessageFromJSON(json['osIs']),
    };
}

export function OsisRuleValidationDataToJSON(value?: OsisRuleValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': ValidationMessageToJSON(value.description),
        'marketingCarriers': ValidationMessageToJSON(value.marketingCarriers),
        'dateTimeRestrictionsTimeZone': ValidationMessageToJSON(value.dateTimeRestrictionsTimeZone),
        'dateTimeRestrictions': value.dateTimeRestrictions === undefined ? undefined : (value.dateTimeRestrictions === null ? null : (value.dateTimeRestrictions as Array<any>).map(DateTimeRestrictionValidationDataToJSON)),
        'fareBasisCodes': value.fareBasisCodes === undefined ? undefined : (value.fareBasisCodes === null ? null : (value.fareBasisCodes as Array<any>).map(ListItemValidationMessageToJSON)),
        'brandAndMarket': ValidationMessageToJSON(value.brandAndMarket),
        'osIs': ValidationMessageToJSON(value.osIs),
    };
}


